import { useTheme } from '@emotion/react';
import { ArrowForward } from '@mui/icons-material';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import { toVideos } from '../../../utils/routes';

const links = {
    "de": "https://youtu.be/sIZZ0pOXTNM",
    "tr": "https://youtu.be/k9pOUFP64HA",
    "pl": "https://youtu.be/l-_Jf4-7Tfk",
    "uk": "https://youtu.be/sIZZ0pOXTNM"
}

export default function VideoOnboarding(props) {
    
    const { i18n, t } = useTranslation();

    let link = links[i18n.language]

    const theme = useTheme();
    const isSuperSmall = useMediaQuery('(max-width:400px)')
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const isSm = useMediaQuery(theme.breakpoints.down('md'));

    const navigate = useNavigate();

    const getWidthAndHeight = () =>  {
        if (isSuperSmall) {
            return [500, 500 * (360 / 640)];
        }
        else if (isXs) {
            return [640, 360];
        } else if (isSm) {
            return [480, 270];
        } else {
            return[640, 360]
        }
    }

    const [width, height] = getWidthAndHeight()

    return(
        <Box>
            {i18n.language === "uk" && <Typography color="error">На жаль, поки що немає перекладу відео українською мовою. Але ми працюємо над цим!</Typography>}
            <ReactPlayer url={link} controls onContextMenu={e => e.preventDefault()} light
                width={width / 2} height={height / 2}
            />
            <Button sx={{mt: 1}} startIcon=<ArrowForward/>
                variant="contained" color="secondary"
                onClick={() => navigate(toVideos)}
            >{t("welcomeVideosText1")}
            </Button>
        </Box>
    )
}